import React from "react";
import { Create, translate } from "react-admin";
import MessageForm from "./MessageForm";

const MessageTitle = ({ translate }) => {
  return <span>{`สร้าง${translate("message.message")}`}</span>;
};

const Title = translate(MessageTitle);

export const MessageCreate = props => (
  <Create title={<Title />} {...props}>
    <MessageForm />
  </Create>
);



// WEBPACK FOOTER //
// ./src/components/message/MessageCreate.js